import { PureComponent } from 'react';
import { connect } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
import unescapedText from 'I18n/utils/unescapedText';
import { addValidationError, removeValidationError } from 'ContentData/actions/ValidationErrors';
import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
// @ts-expect-error no types yet
import withDebouncedInput from 'ContentComponents/components/decorators/withDebouncedInput';
import PickersContext from 'ContentComponents/context/PickersContext';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { EmojiIcon } from 'foundations-assets';
// @ts-expect-error no types yet
import EmojiPickerWrapper from 'ui-addon-emoji-picker/picker/EmojiPickerWrapper';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import { getConfig } from 'tinymce-config/configs/editors/personalization-field';
// @ts-expect-error no types yet
import TinyMCE from 'react-tinymce';
import { CONTACT_FQN, COMPANY_FQN } from 'rich-text-lib/constants/properties';
import { compose } from 'redux';
import { Section } from 'foundations-components/transitional/components/Section';
import { getEncodedValue } from 'tinymce-config/utils/handlers';
import PersonalizationEditorContext from 'ContentComponents/context/PersonalizationEditorContext';
import Routes from 'ContentUtils/Routes';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DebounceExpandingTextArea = withDebouncedInput(ExpandingTextArea);
const i18nKey = key => `ContentComponents.cmv2.fields.text.${key}`;
const mapDispatchToProps = {
  addValidationError,
  removeValidationError
};
const connector = connect(undefined, mapDispatchToProps);
const withPickersContext = WrappedComponent => props => /*#__PURE__*/_jsx(PickersContext.Consumer, {
  children: pickerComponents => /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    pickerComponents: pickerComponents
  }, props))
});
class TextField extends PureComponent {
  constructor(props) {
    super(props);
    this.renderBaseTextField = () => {
      const {
        error = false,
        fieldKey = [],
        readOnly = false,
        value = '',
        placeholder,
        useOnDark,
        show_emoji_picker = false
      } = this.props;
      return /*#__PURE__*/_jsx(DebounceExpandingTextArea, {
        "data-selenium": fieldKey.join('.'),
        error: error,
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        maxHeight: 300,
        paddingInlineEnd: show_emoji_picker ? '1000' : undefined,
        placeholder: placeholder,
        readOnly: readOnly,
        shrink: true,
        use: useOnDark ? 'on-dark' : 'default',
        value: value || ''
      });
    };
    this.renderPersonalizationTextField = () => {
      const {
        allow_new_line: allowNewLine = false,
        fieldKey = [],
        readOnly = false,
        value: dirtyValue = ''
      } = this.props;
      let value = dirtyValue;
      // If the field is using inheritance we get value object
      if (typeof value === 'object') {
        value = value.value;
      }
      return /*#__PURE__*/_jsx(PersonalizationEditorContext.Consumer, {
        children: ({
          __editorRefs,
          setEditorRefs
        }) => {
          const updateTinyMceRef = ref => {
            setEditorRefs(fieldKey.join('.'), ref);
          };
          return /*#__PURE__*/_jsx(Section, {
            "data-test-id": fieldKey.join('.'),
            children: /*#__PURE__*/_jsx(TinyMCE, {
              "data-selenium": fieldKey.join('.'),
              config: this.config,
              content: getEncodedValue(value),
              isMultiline: allowNewLine,
              onBlur: this.onKeyPress,
              onChange: this.onChange,
              onKeyPress: this.onKeyPress,
              readOnly: readOnly,
              tinyMceRef: updateTinyMceRef,
              uniqueKey: fieldKey.join('.')
            })
          });
        }
      });
    };
    this.onChange = this.onChange.bind(this);
    this.validateRegex = this.validateRegex.bind(this);
    this.toggleEmojiPickerOpenState = this.toggleEmojiPickerOpenState.bind(this);
    this.onEmojiPickerOpenChange = this.onEmojiPickerOpenChange.bind(this);
    this.onEmojiSelect = this.onEmojiSelect.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.makeConfig = this.makeConfig.bind(this);
    this.config = this.makeConfig();
    this.state = {
      emojiPickerOpen: false
    };
  }
  componentDidMount() {
    const {
      value = ''
    } = this.props;
    if (value) this.validateRegex(value);
  }
  componentDidUpdate(prevProps) {
    const {
      error: prevError = false
    } = prevProps;
    const {
      error = false,
      fieldKey = []
    } = this.props;
    if (prevError && !error) this.props.removeValidationError(fieldKey);
  }
  get hasDataTokenPicker() {
    const {
      allow_data_tokens: allowDataTokens = false
    } = this.props;
    return allowDataTokens && Routes.isUngated('CMv2:DataTokenPicker');
  }
  makeConfig() {
    const {
      gates = [],
      pickerComponents,
      scopes = [],
      allow_new_line: allowNewLine = false
    } = this.props;
    const supportedCrmObjectFQNs = [CONTACT_FQN];
    if (scopes.includes('crm-product')) {
      supportedCrmObjectFQNs.push(COMPANY_FQN);
    }
    return getConfig({
      appName: '',
      gates,
      scopes,
      hideTokenFallbacks: false,
      pickerComponents,
      supportedCrmObjectFQNs,
      isMultiline: allowNewLine,
      useDataTokens: true
    });
  }
  toggleEmojiPickerOpenState() {
    this.setState({
      emojiPickerOpen: !this.state.emojiPickerOpen
    });
  }
  onEmojiPickerOpenChange({
    target: {
      value
    }
  }) {
    this.setState({
      emojiPickerOpen: value
    });
  }
  onChange(e) {
    const {
      onFieldChange,
      allow_new_line: allowNewLine = false
    } = this.props;
    let value = this.hasDataTokenPicker ? e.target.getContent() : e.target.value;
    if (value && !allowNewLine) {
      value = value.replace(/[\n\r]+/g, '');
    }
    onFieldChange(value);
    this.validateRegex(value);
  }
  onKeyPress(e) {
    const {
      allow_new_line: allowNewLine = false
    } = this.props;
    if (e.key === 'Enter' && !allowNewLine) e.preventDefault();
  }
  onEmojiSelect({
    native
  }) {
    const {
      onFieldChange,
      value = ''
    } = this.props;
    onFieldChange(`${value}${native}`);
  }
  validateRegex(value) {
    const {
      validation_regex: validationRegex = null,
      validation_error_message: validationErrorMessage,
      setError = emptyFunction,
      required = false,
      fieldKey = []
    } = this.props;
    if (!validationRegex || value.match(`^${validationRegex}$`) || !value && !required) {
      setError(null);
    } else {
      const sanitizedValidationErrorMessage = validationErrorMessage && /*#__PURE__*/_jsx(SanitizedLabel, {
        label: validationErrorMessage,
        useStrict: true
      });
      setError(sanitizedValidationErrorMessage || unescapedText(i18nKey('invalidFormat'), {
        text: value,
        regex: validationRegex
      }));
      this.props.addValidationError(fieldKey);
    }
  }
  renderEmojiPicker() {
    const {
      show_emoji_picker = false
    } = this.props;
    if (!show_emoji_picker) return null;
    return /*#__PURE__*/_jsx(FormControl, {
      children: /*#__PURE__*/_jsx(View, {
        marginInlineStart: "-1000" // Forces textarea focus border to go around emoji picker
        ,
        children: /*#__PURE__*/_jsx(PickersContext.Consumer, {
          children: ({
            EmojiPicker
          }) => EmojiPicker && /*#__PURE__*/_jsx(EmojiPickerWrapper, {
            popoverProps: {
              placement: 'bottom left',
              open: this.state.emojiPickerOpen,
              closeOnOutsideClick: true,
              onOpenChange: this.onEmojiPickerOpenChange
            },
            autoFocus: true,
            onClick: this.onEmojiSelect,
            useDefaultFilter: true,
            PickerContent: EmojiPicker,
            children: /*#__PURE__*/_jsx(IconButton, {
              use: this.props.useOnDark ? 'primary-white' : 'transparent',
              onClick: this.toggleEmojiPickerOpenState,
              marginBlockStart: "25",
              children: /*#__PURE__*/_jsx(EmojiIcon, {
                size: "400"
              })
            })
          })
        })
      })
    });
  }
  render() {
    const {
      show_emoji_picker = false
    } = this.props;
    const input = this.hasDataTokenPicker ? this.renderPersonalizationTextField() : this.renderBaseTextField();
    if (show_emoji_picker) {
      return /*#__PURE__*/_jsxs(InputGroup, {
        use: "itemRight",
        children: [/*#__PURE__*/_jsx(FormControl, {
          children: input
        }), this.renderEmojiPicker()]
      });
    }
    return input;
  }
}
export default compose(connector, withPickersContext)(TextField);